// /Users/vijayakumarreddygajjala/zninth/Ascentra-2.0/my-ascentra-app/src/Common/utils/utils.js

export const generateGuid = () => {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  return `${formattedDate} ${formattedTime}`;
};


export const getTimeDiffInSeconds = (endTime, startTime) => {
  if (!endTime || !startTime) {
    return "N/A"; // Or handle it in a way that makes sense for your application
  }
  const end = new Date(endTime);
  const start = new Date(startTime);

  if (isNaN(end.getTime()) || isNaN(start.getTime())) {
    return "Invalid Date"; // Or handle it in a way that makes sense for your application
  }

  const diffInMilliseconds = end.getTime() - start.getTime();

  // const diffInSeconds = Math.round(diffInMilliseconds / 1000);
  const diffInSeconds = Math.round(diffInMilliseconds / 1000);

  return diffInSeconds;
};

export const extractPlaceholders = (url) => {
  const placeholders = [];
  const regex = /\{([^}]+)\}/g; // Regular expression to match {word}

  let match;
  while ((match = regex.exec(url)) !== null) {
    placeholders.push(match[1]); // Push the captured word (group 1)
  }

  return placeholders;
}

export const getDynamicSchema = (placeholders) => {
  const properties = {};
  const required = [];

  placeholders.forEach((placeholder, index) => {
    const propertyName = placeholder; // Use the placeholder name directly
    properties[propertyName] = {
      type: "string",
    };
    required.push(propertyName); // Add all placeholders to the required array
  });

  const schema = {
    type: "object",
    properties: properties,
    required: required,
  };

  return JSON.stringify(schema, null, 2);
};

